import styled from '@emotion/styled';

// Components
import Grid from '../../../ComponentLibrary/oc-grid';
import Media from '../../../ComponentLibrary/oc-media';
import { H3 } from '../../../OC/oc-h';

const ModalH3 = styled(H3)`
  margin-bottom: 16px;
`;

const StyledMedia = styled(Media)`
  outline: 0px;
`;

const RoofAccessInfoModal = ({}) => (
  <>
    <ModalH3>Understanding Roof Complexity</ModalH3>
    <p>Most residential roofs will fall under the following three options:</p>
    <Grid selectedSize={3} selectedSizeTablet={3}>
      <div>
        <StyledMedia img="https://imagecdn.owenscorning.com/ocimages/image/upload/c_crop,h_2351,w_3779,x_175,y_112/f_auto,q_auto/f_auto/v1/pagebuilder/uploads/prod/14701551/Desert_Rose_Gallery_Image" />
        <p>
          <strong>Simple:</strong> Only 1 pitch or slope of the roof on all sides. No valleys or multiple pitches.
        </p>
      </div>
      <div>
        <StyledMedia img="https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_auto/v1/uploads/prod/9016/trudefdurationdesigner1" />
        <p>
          <strong>Moderate:</strong> 2 or 3 pitches. Only 1-2 valleys.
        </p>
      </div>
      <div>
        <StyledMedia img="https://imagecdn.owenscorning.com/ocimages/image/upload/h_173,w_276/v1676319303/roofing/widgets/quoting-widget/qw-house-3.jpg" />
        <p>
          <strong>Complex:</strong> Multiple pitches, valleys, and rises.
        </p>
      </div>
    </Grid>
    <p>If none of these options match your roof, please select the closest one.</p>
  </>
);

export default RoofAccessInfoModal;
